import {
  GET_PLACE_LIST_START,
  GET_PLACE_LIST,
  GET_PLACE_LIST_ERROR,
  GET_PLACE_LIST_PAGEBALE_START,
  GET_PLACE_LIST_PAGEBALE,
  GET_PLACE_LIST_PAGEBALE_ERROR,
  GET_PLACE_FILTER_LIST,
  GET_PLACE_FILTER_LIST_START,
  GET_PLACE_FILTER_LIST_ERROR,
  GET_PLACE_LIST_BY_AUTONOMOUS_PROVINCE_START,
  GET_PLACE_LIST_BY_AUTONOMOUS_PROVINCE,
  GET_PLACE_LIST_BY_AUTONOMOUS_PROVINCE_ERROR,
  GET_PLACE_LIST_WITHOUT_AUTONOMOUS_PROVINCE_START,
  GET_PLACE_LIST_WITHOUT_AUTONOMOUS_PROVINCE,
  GET_PLACE_LIST_WITHOUT_AUTONOMOUS_PROVINCE_ERROR,
  UPDATE_PLACE,
  UPDATE_PLACE_START,
  UPDATE_PLACE_ERROR,
  CREATE_PLACE,
  CREATE_PLACE_START,
  CREATE_PLACE_ERROR,
  CLEAR_PLACE_LIST,
} from '../actions/types';
import { numberOfItemsPerPage } from '../constants/globals';

const initialState = {
  placeList: [],
  place: {},
  loading: false,
  error: undefined,
  totalElements: '',
};

const clearList = (state) => {
  return {
    ...state,
    placeList: [],
  };
};

const findAllPlace = (state, action) => {
  return {
    ...state,
    loading: false,
    placeList: action.payload,
    error: undefined,
  };
};

const findAllPlaceStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findAllPlaceError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const updatePlace = (state, action) => {
  return {
    ...state,
    loading: false,
    placeList: state.placeList.map((place) =>
      place.id === action.payload.id ? action.payload : place
    ),
    error: undefined,
  };
};

const updatePlaceStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const updatePlaceError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const createPlace = (state, action) => {
  return {
    ...state,
    loading: false,
    placeList: [action.payload].concat(
      state.placeList.length === numberOfItemsPerPage
        ? state.placeList.filter(
            (req) => req !== state.placeList[state.placeList.length - 1]
          )
        : state.placeList
    ),
    error: undefined,
  };
};

const createPlaceStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const createPlaceError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllPlaceByAutonomousProvince = (state, action) => {
  return {
    ...state,
    loading: false,
    placeList: action.payload,
    error: undefined,
  };
};

const findAllPlaceByAutonomousProvinceStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findAllPlaceByAutonomousProvinceError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllPlaceWithoutAutonomousProvince = (state, action) => {
  return {
    ...state,
    loading: false,
    placeList: action.payload,
    error: undefined,
  };
};

const findAllPlaceWithoutAutonomousProvinceStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findAllPlaceWithoutAutonomousProvinceError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllPlacePageableStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findAllPlacePageable = (state, action) => {
  return {
    ...state,
    loading: false,
    numberOfPages: action.payload[1],
    totalElements: action.payload[2],
    placeList: action.payload[0],
  };
};

const findAllPlacePageableError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_PLACE_LIST:
      return findAllPlace(state, action);
    case GET_PLACE_LIST_START:
      return findAllPlaceStart(state);
    case GET_PLACE_LIST_ERROR:
      return findAllPlaceError(state, action);

    case GET_PLACE_LIST_BY_AUTONOMOUS_PROVINCE:
      return findAllPlaceByAutonomousProvince(state, action);
    case GET_PLACE_LIST_BY_AUTONOMOUS_PROVINCE_START:
      return findAllPlaceByAutonomousProvinceStart(state);
    case GET_PLACE_LIST_BY_AUTONOMOUS_PROVINCE_ERROR:
      return findAllPlaceByAutonomousProvinceError(state, action);

    case GET_PLACE_LIST_WITHOUT_AUTONOMOUS_PROVINCE:
      return findAllPlaceWithoutAutonomousProvince(state, action);
    case GET_PLACE_LIST_WITHOUT_AUTONOMOUS_PROVINCE_START:
      return findAllPlaceWithoutAutonomousProvinceStart(state);
    case GET_PLACE_LIST_WITHOUT_AUTONOMOUS_PROVINCE_ERROR:
      return findAllPlaceWithoutAutonomousProvinceError(state, action);

    case GET_PLACE_LIST_PAGEBALE:
    case GET_PLACE_FILTER_LIST:
      return findAllPlacePageable(state, action);
    case GET_PLACE_LIST_PAGEBALE_START:
    case GET_PLACE_FILTER_LIST_START:
      return findAllPlacePageableStart(state);
    case GET_PLACE_LIST_PAGEBALE_ERROR:
    case GET_PLACE_FILTER_LIST_ERROR:
      return findAllPlacePageableError(state, action);

    case UPDATE_PLACE:
      return updatePlace(state, action);
    case UPDATE_PLACE_START:
      return updatePlaceStart(state);
    case UPDATE_PLACE_ERROR:
      return updatePlaceError(state, action);

    case CREATE_PLACE:
      return createPlace(state, action);
    case CREATE_PLACE_START:
      return createPlaceStart(state);
    case CREATE_PLACE_ERROR:
      return createPlaceError(state, action);

    case CLEAR_PLACE_LIST:
      return clearList(state);

    default:
      return state;
  }
}
